import { ActionTypes } from '../../constants/ActionTypes';
import { IFastSignReducer } from '../../interfaces';

const INIT_STATE: IFastSignReducer = {
  employeePositionFastSignature: [],
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.GET_FAST_SING_SUCCESS: {
      const s = state;
      s.employeePositionFastSignature.push(...action.payload.data);
      return {
        ...s,
      };
    }

    case ActionTypes.GET_FAST_SING: {
      return {
        ...state,
        employeePositionFastSignature: [],
      };
    }

    default:
      return state;
  }
};
